// removed by extract-text-webpack-plugin
module.exports = {"gwCoverage":"ReadonlyCoverages-hashed__gwCoverage__3M30M","gwCoverage_last":"ReadonlyCoverages-hashed__gwCoverage_last__FxUh7","gwCoverage__name":"ReadonlyCoverages-hashed__gwCoverage__name__1hyBE","gwCoverage__terms":"ReadonlyCoverages-hashed__gwCoverage__terms__1575T","gwCoverage__term":"ReadonlyCoverages-hashed__gwCoverage__term__397zj","gwCoverage__termName":"ReadonlyCoverages-hashed__gwCoverage__termName__24MMG","gwCoverage__termAmount":"ReadonlyCoverages-hashed__gwCoverage__termAmount__I-YOc"};


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/readonlycoverages/ReadonlyCoverages-hashed.scss
// module id = 659
// module chunks = 0